import { useEffect, useRef } from 'react';
import { useTheme } from 'next-themes';
import { useDeviceOrganization } from './useDeviceOrganization';

/**
 * Applies the organization's default theme (light/dark) for users
 * who haven't explicitly set their own theme preference.
 *
 * If the user has already toggled the theme (stored in localStorage
 * under 'pwa-handel-theme'), their choice is respected.
 */
export function useOrgDefaultTheme() {
  const { defaultTheme, loading } = useDeviceOrganization();
  const { setTheme } = useTheme();
  const appliedRef = useRef(false);

  useEffect(() => {
    if (loading || appliedRef.current) return;

    // Check if the user has already made an explicit theme choice
    const userChoice = localStorage.getItem('pwa-handel-theme');
    if (userChoice) return;

    if (defaultTheme) {
      setTheme(defaultTheme);
      appliedRef.current = true;
    }
  }, [defaultTheme, loading, setTheme]);
}
